import React, {useState} from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { AppContext, useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import USStates from "../components/USStates"
import "./Address.css";

export default function Address(props) {
    const { business, otherAddresses, setOtherAddresses } = useAppContext();
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);

    const [fields, handleFieldChange] = useFormFields({
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
    });

    function setState(stateCode) {
        fields.state = stateCode;
    }

    const removeAddress = async (event, address, index) => {
        event.preventDefault();

        //console.log("*****removeAddress: address: " + address);
        try {
            const newAddresses = otherAddresses.filter((address, i) => i !== index);
            setOtherAddresses(newAddresses);
        } catch (e) {
            onError(e);
        }
    }

    function renderAddress(address1, address2, city, state, zip) {
        let display = address1;
        if (address2) {
            display += " " + address2;
        }
        display += ", " + city + ", " + state + " " + zip;
        return (
            <div className="linkBtn-text">{display}</div>
        );
    }

    const clickClose = () => setShow(false);
    const clickShow = (e) => {
        e.preventDefault();
        setShow(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        const isValid = form.checkValidity();

        setValidated(true);

        if (isValid) {
            let address = {};
            address.id = otherAddresses.length + 1;
            address.address1 = fields.address1;
            address.address2 = fields.address2;
            address.city = fields.city;
            address.state = fields.state;
            address.zip = fields.zip;
            otherAddresses.push(address);
            setOtherAddresses(otherAddresses);
            setShow(false);
            setValidated(false);
        }
    }

    return (
        <div>
            <div>
                <div className="text-linkBtn row-bottom-20">
                    <label>Primary address</label>
                    {renderAddress(business.address1, business.address2, business.city, business.state, business.zip)}
                </div>
                {otherAddresses && otherAddresses.length > 0 && (
                    <div>
                        { otherAddresses.map((address, index) => {
                            return (
                                <div key={index} className="linkBtn row-bottom-20">
                                        <Button className="" onClick={(e) => removeAddress(e, address, index)}>
                                            <FontAwesomeIcon icon="times-circle"></FontAwesomeIcon>
                                        </Button>
                                    {renderAddress(address.address1, address.address2, address.city, address.state, address.zip)}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className="linkBtn"> 
                <Button onClick={clickShow}>
                    <FontAwesomeIcon icon="plus-circle"></FontAwesomeIcon> 
                </Button>
                <div className="link linkBtn-link" onClick={clickShow}>Add another location</div>
            </div>
            <div >
                <Modal show={show} onHide={clickClose} backdrop="static" className="App">
                    <Modal.Header closeButton>
                        <Modal.Title><h2>Add Location</h2></Modal.Title>
                    </Modal.Header>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Row>
                            <Form.Group as={Col} controlId="address1">
                                <Form.Control 
                                    type="text" 
                                    required 
                                    size="sm" 
                                    autoFocus={true}
                                    onChange={handleFieldChange} />
                                    <Form.Label>Address 1</Form.Label>
                                <Form.Control.Feedback type="invalid">Please provide a valid address.</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="address2">
                                <Form.Control 
                                    type="text" 
                                    size="sm" 
                                    onChange={handleFieldChange} />
                                <Form.Label>Address 2</Form.Label>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="city">
                                <Form.Control 
                                    type="text" 
                                    required 
                                    size="sm"
                                    onChange={handleFieldChange} />
                                <Form.Label>City</Form.Label>
                                <Form.Control.Feedback type="invalid">Please provide a valid city.</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="6" controlId="state">
                                <AppContext.Provider value={{ setState }}>
                                    <USStates id="state" isRequired={true} />
                                </AppContext.Provider>
                                <Form.Label>State</Form.Label>
                                <Form.Control.Feedback type="invalid">Please provide a valid state.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="zip">
                                <Form.Control 
                                    type="text" 
                                    pattern="[0-9]{5}"
                                    required 
                                    size="sm"  
                                    maxLength="5"                      
                                    onChange={handleFieldChange} />
                                <Form.Label>Zip</Form.Label>
                                <Form.Control.Feedback type="invalid">Please provide a valid zip.</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="modalButtons">
                            <Button variant="primary" type="submit">
                                NEXT
                            </Button>
                        </div>
                    </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        </div>
    );
}